import i18n, { setApplicationLanguage } from "../i18n";
import {
  getProfilePreferences,
  saveProfilePreferences,
} from "./profileSettingService";
import {
  getPreferredTimeZone,
  persistPreferredLanguage,
  persistPreferredTimeZone,
} from "../utils/userPreferences";

function hasAuthenticatedSession() {
  try {
    return Boolean(
      JSON.parse(sessionStorage.getItem("token_store") || "null")?.token
    );
  } catch (error) {
    return false;
  }
}

export async function synchronizeProfileLocale() {
  if (!hasAuthenticatedSession()) return null;
  try {
    const { data } = await getProfilePreferences();
    if (data?.language) {
      persistPreferredLanguage(data.language);
      persistPreferredTimeZone(data.timeZone);
      await i18n.changeLanguage(data.language);
    }
    return data;
  } catch (error) {
    return null;
  }
}

export async function changeAndPersistLanguage(language) {
  const normalized = await setApplicationLanguage(language);
  if (hasAuthenticatedSession()) {
    try {
      await saveProfilePreferences({
        language: normalized,
        locale: normalized === "en" ? "en-US" : "es-DO",
        timeZone: getPreferredTimeZone(),
      });
    } catch (error) {
      // Local persistence keeps the UI usable while the API is unavailable.
    }
  }
  return normalized;
}
